import { act } from 'react'
import WaveSurfer from 'wavesurfer.js'

/* Player Base */
'use strict'

/* Setup */
const article_url = document.location.href
const fetch_base_url = article_url.indexOf('.local') > 0 ? 'https://storyflashplayer.kolossum.local' : 'https://player.storyflash.de'
const fetch_url = fetch_base_url + '/api/article/get'
const fetch_summary_url = fetch_base_url + '/api/article/get_summary'
const statistic_url = fetch_base_url + '/api/statistic/set'
const summary_statistic_url = fetch_base_url + '/api/statistic/set_summary'
const player_hash = crypto.randomUUID()
const player_setup_done_event = new Event('player_setup_done');

if (typeof com_adswizz_synchro_getListenerId === 'function') {
    console.log('listenerid', com_adswizz_synchro_getListenerId(), aw_0_req_gdpr, us_privacy)
}

let statistics_send = {
        load: false,
        play: false,
        progress: 0
    },
    progress_in_progress = false,
    progress_value = 0,
    ad_in_progress = false,
    preroll_played = false,
    postroll_played = false

let playerLoadInterval,
    playerCheckMaxAttempt = 15,
    playerCheckAttempted = 0

let has_border = false,
    show_waveform = true,
    show_progress = false,
    show_logo = true,
    show_skip_buttons = true,
    is_transparent = true,
    text_color = '#000000',
    border_color = '#000000',
    progress_color = '#000000',
    background_color = '#FFFFFF',
    button_color = '#000000',
    skip_button_color = '#000000',
    button_border_color = '#000000',
    button_background_color = '#FFFFFF',
    button_width = '64px',
    button_height = '64px',
    button_border_radius = '50%',
    button_border_width = '4px',
    button_border_style = 'solid',
    button_has_border = true,
    button_has_background = true,
    headline = null,
    headline_font = 'Helvetica, Arial, sans-serif',
    base_headline_font = 'Helvetica, Arial, sans-serif',
    headline_color = '#000000',
    headline_size = '12px',
    base_headline_size = '12px',
    text_font = 'Helvetica, Arial, sans-serif',
    base_text_font = 'Helvetica, Arial, sans-serif',
    text_size = '12px',
    base_text_size = '12px',
    wavesurfer

let scriptName = new URL(document.currentScript.src).pathname.split('/').pop(),
    baseName = scriptName.split('.').shift(),
    scriptUrl = new URL(document.currentScript.src)

/* Check for container param */
let containerElem = 'data-storyflash-audio-player';
if (scriptUrl.searchParams.get('container') != null) {
    containerElem = scriptUrl.searchParams.get('container')
}

let checkForPlayer = () => {
    /* Check for element */
    if (document.querySelector('['+containerElem+']')) {
        /* Make fetch call */
        document.querySelector('body').classList.add( 'storyflash-audio-player-loaded' )
        getArticleAudio()
        clearInterval(playerLoadInterval)
    } else {
        playerCheckAttempted++
        if (playerCheckAttempted >= playerCheckMaxAttempt) {
            clearInterval(playerLoadInterval)
        }
    }
},
getArticleAudio = () => {
    /* Make fetch call */
    let request_data =
        {
            article_url: article_url,
            hash: player_hash,
            listenerId: typeof com_adswizz_synchro_getListenerId === 'function' ? com_adswizz_synchro_getListenerId() : false,
            aw_0_req_gdpr: typeof aw_0_req_gdpr !== 'undefined' ? aw_0_req_gdpr : false
        },
        request_url = fetch_url

    if (scriptUrl.searchParams.get('hash') != null) {
        request_data['article'] = scriptUrl.searchParams.get('hash')
    }

    if (
        baseName != null &&
        baseName == 'player_preview'
    ) {
        request_data['preview_mode'] = true
    }

    if (
        baseName != null &&
        baseName == 'player_summary'
    ) {
        request_url = fetch_summary_url
    }

    let response = fetch(request_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(request_data)
    }).then(api_response => {
        if (!api_response.ok) {
            if (api_response.status === 404) {
                throw new Error('Data not found')
            } else if (api_response.status === 500) {
                throw new Error('Server error')
            } else {
                throw new Error('Network response was not ok')
            }
        }
        return api_response.json()
    }).then(data => {
        initPlayer(data)
        statistics_send['load'] = true
    }).catch(error => {
        console.error('Error:', error)
    })
},
initPlayer = (articleData) => {
    /* Setup */
    if (articleData.url != null && document.querySelector('['+containerElem+']')) {
        let playerContainer = document.querySelector('['+containerElem+']'),
            mediaElem = document.createElement('audio'),
            mediaBlob,
            headlineContainer = document.createElement('div'),
            headlineText = document.createElement('p'),
            topContainer = document.createElement('div'),
            bottomContainer = document.createElement('div'),
            actionsContainer = document.createElement('div'),
            playButton = document.createElement('a'),
            playButtonImage = document.createElement('img'),
            pauseButtonImage = document.createElement('img'),
            pauseButton = document.createElement('a'),
            infoContainer = document.createElement('div'),
            visualisationContainer = document.createElement('div'),
            progressbarContainer = document.createElement('div'),
            progressbarBase = document.createElement('span'),
            progressbarProgress = document.createElement('span'),
            progressbarDot = document.createElement('span'),
            brandingContainer = document.createElement('div'),
            brandingLogo = document.createElement('img'),
            brandingLink = document.createElement('a'),
            timeContainer = document.createElement('div'),
            timeRemaining = document.createElement('span'),
            timePlayed = document.createElement('span'),
            timeDivider = document.createElement('span'),
            timeTotal = document.createElement('span'),
            controlsContainer = document.createElement('div'),
            playbackRateList = document.createElement('ul'),
            skipList = document.createElement('ul'),
            rewindItem = document.createElement('li'),
            forwardItem = document.createElement('li'),
            rewindButton = document.createElement('a'),
            forwardButton = document.createElement('a'),
            waveformContainer = document.createElement('div'),
            metaContainer = document.createElement('div'),
            prerollAudio = document.createElement('audio'),
            postrollAudio = document.createElement('audio')

        /* Setup preroll/postroll */
        prerollAudio.setAttribute('id', 'storyflash-preroll')
        postrollAudio.setAttribute('id', 'storyflash-postroll')

        /* Check for preroll/postroll */
        if (articleData.preroll) {
            prerollAudio.setAttribute('src', articleData.preroll)
            prerollAudio.load()
        }
        if (articleData.postroll) {
            postrollAudio.setAttribute('src', articleData.preroll)
            postrollAudio.load()
        }

        /* Assign audio blob */
        mediaElem.src = articleData.url
        mediaElem.addEventListener('loadedmetadata', (ev) => {
            let dateObj = new Date(mediaElem.duration * 1000),
                hours = dateObj.getUTCHours(),
                minutes = dateObj.getUTCMinutes(),
                seconds = dateObj.getSeconds(),
                timeString

            if (hours > 0) {
                timeString = hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0')
            } else {
                timeString = minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0')
            }

            timeTotal.textContent = timeString
            timeRemaining.textContent = timeString
        })
        mediaElem.addEventListener('timeupdate', (ev) => {
            let playedTime = new Date(mediaElem.currentTime * 1000),
                playedHours = playedTime.getUTCHours(),
                playedMinutes = playedTime.getUTCMinutes(),
                playedSeconds = playedTime.getSeconds(),
                playedTimeString,
                remainingTime = new Date((mediaElem.duration * 1000) - (mediaElem.currentTime * 1000)),
                remainingHours = remainingTime.getUTCHours(),
                remainingMinutes = remainingTime.getUTCMinutes(),
                remainingSeconds = remainingTime.getSeconds(),
                remainingTimeString

            if (playedHours > 0) {
                playedTimeString = playedHours.toString().padStart(2, '0') + ':' + playedMinutes.toString().padStart(2, '0') + ':' + playedSeconds.toString().padStart(2, '0')
                remainingTimeString = remainingHours.toString().padStart(2, '0') + ':' + remainingMinutes.toString().padStart(2, '0') + ':' + remainingSeconds.toString().padStart(2, '0')
            } else {
                playedTimeString = playedMinutes.toString().padStart(2, '0') + ':' + playedSeconds.toString().padStart(2, '0')
                remainingTimeString = remainingMinutes.toString().padStart(2, '0') + ':' + remainingSeconds.toString().padStart(2, '0')
            }

            timePlayed.textContent = playedTimeString
            timeRemaining.textContent = remainingTimeString

            /* Make fetch call */
            let raw_progress = (mediaElem.currentTime/mediaElem.duration)*100,
                progress_value = Math.floor(raw_progress)

            /* Set progress bar */
            progressbarProgress.style.width = raw_progress + '%'
            progressbarDot.style.left = raw_progress + '%'

            if (progress_value >= 75 && progress_value < 100) {
                progress_value = 75
            } else if(progress_value >= 50) {
                progress_value = 50
            } else if(progress_value >=25) {
                progress_value = 25
            } else {
                progress_value = 0
            }

            if (
                progress_value > 0 &&
                (progress_value > statistics_send['progress']) &&
                progress_in_progress == false
            ) {
                progress_in_progress = true

                let statistic_request_url = statistic_url,
                    event_name = 'progress'

                if (
                    baseName != null &&
                    baseName == 'player_summary'
                ) {
                    statistic_request_url = summary_statistic_url
                    event_name = 'progress_summary'
                }

                let response = fetch(statistic_request_url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({article_url: article_url, hash: player_hash, event: event_name, value: progress_value})
                }).then(api_response => {
                    if (!api_response.ok) {
                        if (api_response.status === 404) {
                            throw new Error('Data not found')
                        } else if (api_response.status === 500) {
                            throw new Error('Server error')
                        } else {
                            throw new Error('Network response was not ok')
                        }
                    }
                    return api_response.json()
                }).then(data => {
                    statistics_send['progress'] = progress_value
                    progress_in_progress = false
                }).catch(error => {
                    console.error('Error:', error)
                })
            }
        })
        mediaElem.addEventListener('ended', (ev) => {
            if (postrollAudio.src && postroll_played == false) {
                ad_in_progress = true
                postroll_played = false
                pauseButton.style.opacity = 0.5
                pauseButton.style.cursor = 'default'
                playButton.style.opacity = 0.5
                controlsContainer.style.opacity = 0.5
                controlsContainer.querySelectorAll('a').forEach((elem) => {
                    elem.style.pointerEvents = 'none'
                    elem.style.cursor = 'default'
                })
                postrollAudio.play()
                postrollAudio.addEventListener('ended', function(ev) {
                    ad_in_progress = false
                    postroll_played = true
                    pauseButton.style.opacity = 1
                    playButton.style.opacity = 1
                    pauseButton.style.cursor = 'pointer'
                    pauseButton.style.display = 'none'
                    playButton.style.display = 'flex'
                    controlsContainer.style.opacity = 1
                    controlsContainer.querySelectorAll('a').forEach((elem) => {
                        elem.style.pointerEvents = 'auto'
                        elem.style.cursor = 'pointer'
                    })
                })
            } else {
                pauseButton.style.display = 'none'
                playButton.style.display = 'flex'
            }

            if (statistics_send['progress'] < 100) {
                let statistic_request_url = statistic_url,
                    event_name = 'progress'

                if (
                    baseName != null &&
                    baseName == 'player_summary'
                ) {
                    statistic_request_url = summary_statistic_url
                    event_name = 'progress_summary'
                }

                let response = fetch(statistic_request_url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({article_url: article_url, hash: player_hash, event: event_name, value: 100})
                }).then(api_response => {
                    if (!api_response.ok) {
                        if (api_response.status === 404) {
                            throw new Error('Data not found')
                        } else if (api_response.status === 500) {
                            throw new Error('Server error')
                        } else {
                            throw new Error('Network response was not ok')
                        }
                    }
                    return api_response.json()
                }).then(data => {
                    statistics_send['progress'] = 100
                }).catch(error => {
                    console.error('Error:', error)
                })
            }
        })
        playerContainer.append(mediaElem)

        /* Setup colors */
        if (articleData.player != null) {
            if (articleData.player.border != null) {
                has_border = articleData.player.border
            }
            if (articleData.player.transparent != null) {
                is_transparent = articleData.player.transparent
            }
            if (articleData.player.border_color != null) {
                border_color = articleData.player.border_color
            }
            if (articleData.player.text_color != null) {
                text_color = articleData.player.text_color
            }
            if (articleData.player.background_color != null) {
                background_color = articleData.player.background_color
            }
            if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                background_color = '#FFFFFF'
                is_transparent = false
            }
            if (articleData.player.progress_color != null) {
                progress_color = articleData.player.progress_color
            }
            if (articleData.player.button_color != null) {
                button_color = articleData.player.button_color
            }
            if (articleData.player.skip_button_color != null) {
                skip_button_color = articleData.player.skip_button_color
            }
            if (articleData.player.headline != null) {
                headline = articleData.player.headline
            }
            if (articleData.player.headline_color != null) {
                headline_color = articleData.player.headline_color
            }
            if (articleData.player.headline_size != null) {
                headline_size = articleData.player.headline_size
            }
            if (articleData.player.headline_font != null) {
                headline_font = articleData.player.headline_font
            }
            if (articleData.player.text_font != null) {
                text_font = articleData.player.text_font
            }
            if (articleData.player.show_waveform !== null) {
                if (articleData.player.show_waveform === 0) {
                    show_waveform = false
                } else {
                    show_waveform = articleData.player.show_waveform
                }
            }
            if (articleData.player.show_progress != null) {
                show_progress = articleData.player.show_progress
            }
            if (articleData.player.show_logo != null) {
                show_logo = articleData.player.show_logo
            }
            if (articleData.player.show_skip_buttons != null) {
                show_skip_buttons = articleData.player.show_skip_buttons
            }
            if (articleData.player.button_width != null) {
                button_width = articleData.player.button_width
            }
            if (articleData.player.button_height != null) {
                button_height = articleData.player.button_height
            }
            if (articleData.player.button_border_radius != null) {
                button_border_radius = articleData.player.button_border_radius
            }
            if (articleData.player.button_border_color != null) {
                button_border_color = articleData.player.button_border_color
            }
            if (articleData.player.button_border_width != null) {
                button_border_width = articleData.player.button_border_width
            }
            if (articleData.player.button_has_border !== null) {
                if (articleData.player.button_has_border === 0) {
                    button_has_border = false
                } else {
                    button_has_border = articleData.player.button_has_border
                }
            }
            if (articleData.player.button_has_background != null) {
                button_has_background = articleData.player.button_has_background
            }
            if (articleData.player.button_border_style != null) {
                button_border_style = articleData.player.button_border_style
            }
            if (articleData.player.button_background_color != null) {
                button_background_color = articleData.player.button_background_color
            }
        }

        playerContainer.style.display = 'flex'
        playerContainer.style.boxSizing = 'border-box'
        playerContainer.style.flexDirection = 'row'
        playerContainer.style.flexWrap = 'wrap'
        playerContainer.style.justifyContent = 'flex-start'
        playerContainer.style.alignItems = 'center'
        playerContainer.style.marginTop = '12px'
        playerContainer.style.marginBottom = '12px'
        playerContainer.style.borderColor = border_color

        if (is_transparent == false && background_color != null) {
            playerContainer.style.backgroundColor = background_color
        }

        if (has_border == true) {
            playerContainer.style.borderStyle = 'solid'
            playerContainer.style.borderWidth = '1px'
            playerContainer.style.padding = '12px'
        }

        headlineContainer.classList.add('storyflash-audio-player-headline')
        headlineText.style.fontSize = headline_size
        headlineText.style.lineHeight = '1'
        headlineText.style.fontFamily = headline_font
        headlineText.style.color = headline_color
        headlineText.style.marginTop = '0px'
        headlineText.style.marginBottom = '12px'
        headlineText.textContent = headline
        headlineContainer.append(headlineText)

        topContainer.style.display = 'flex'
        topContainer.style.boxSizing = 'border-box'
        topContainer.style.flexDirection = 'row'
        topContainer.style.justifyContent = 'flex-start'
        topContainer.style.alignItems = 'center'
        topContainer.style.width = '100%'

        bottomContainer.style.display = 'flex'
        bottomContainer.style.boxSizing = 'border-box'
        bottomContainer.style.flexDirection = 'column'
        bottomContainer.style.justifyContent = 'center'
        bottomContainer.style.alignItems = 'normal'
        bottomContainer.style.width = '100%'

        actionsContainer.classList.add('storyflash-audio-player-actions'),
        waveformContainer.classList.add('storyflash-audio-player-waveform'),
        waveformContainer.style.marginBottom = '10px'
        metaContainer.classList.add('storyflash-audio-player-meta')
        playButton.classList.add('storyflash-audio-player-actions-play')
        pauseButton.classList.add('storyflash-audio-player-actions-pause')
        timeContainer.classList.add('storyflash-audio-player-meta-time')
        controlsContainer.classList.add('storyflash-audio-player-meta-controls')
        brandingContainer.classList.add('storyflash-audio-player-meta-branding')

        if (!show_logo) {
            brandingContainer.style.display = 'none'
        }

        /* Initiate waveform */
        wavesurfer = WaveSurfer.create({
            container: waveformContainer,
            waveColor: 'rgb(182, 182, 182)',
            progressColor: progress_color,
            backend: 'MediaElement',
            //url: articleData.url,
            // Set a bar width
            barWidth: 2,
            // Optionally, specify the spacing between bars
            barGap: 1,
            // And the bar radius
            barRadius: 2,
            height: 36,
            cursorWidth: 0,
            interact: false,
            dragToSeek: false,
            hideScrollbar: false,
        })
        wavesurfer.setMediaElement(mediaElem)
        wavesurfer.load(mediaElem.src)

        /* Progressbar */
        progressbarContainer.classList.add('storyflash-audio-player-progressbar-container')
        progressbarContainer.style.position = 'relative'
        progressbarContainer.style.marginBottom = '10px'
        progressbarBase.style.display = 'block'
        progressbarBase.style.backgroundColor = '#F0F0F0'
        progressbarBase.style.height = '4px'
        progressbarBase.style.width = '100%'
        progressbarProgress.classList.add('storyflash-audio-player-progressbar-progress')
        progressbarProgress.style.height = '4px'
        progressbarProgress.style.width = '0%'
        progressbarProgress.style.display = 'block'
        progressbarProgress.style.position = 'absolute'
        progressbarProgress.style.top = '0'
        progressbarProgress.style.backgroundColor = progress_color
        progressbarDot.classList.add('storyflash-audio-player-progressbar-dot')
        progressbarDot.style.backgroundColor = progress_color
        progressbarDot.style.display = 'block'
        progressbarDot.style.width = '12px'
        progressbarDot.style.height = '12px'
        progressbarDot.style.borderRadius = '50%'
        progressbarDot.style.position = 'absolute'
        progressbarDot.style.left = '0%'
        progressbarDot.style.top = '-4px'
        progressbarContainer.append(progressbarBase, progressbarProgress, progressbarDot)

        if (!show_progress) {
            progressbarContainer.style.display = 'none'
        }

        setWaveform(waveformContainer, show_waveform)

        /* Visualisation */
        visualisationContainer.classList.add('storyflash-audio-player-visualization-container')

        infoContainer.style.flex = 1

        /* Actions */
        actionsContainer.style.width = button_width
        actionsContainer.style.boxSizing = 'border-box'
        actionsContainer.style.margin = '0 12px 0 0'

        /* Buttons */
        playButton.style.display = 'flex'
        playButton.style.flexDirection = 'column'
        playButton.style.justifyContent = 'center'
        playButton.style.alignItems = 'center'
        playButton.style.width = button_width
        playButton.style.height = button_height
        playButton.style.borderWidth = button_border_width
        playButton.style.borderColor = button_border_color
        playButton.style.borderRadius = button_border_radius
        //playButton.style.borderStyle = button_border_style
        playButton.style.backgroundColor = button_background_color
        playButton.style.cursor = 'pointer'
        pauseButton.style.display = 'none'
        pauseButton.style.flexDirection = 'column'
        pauseButton.style.justifyContent = 'center'
        pauseButton.style.alignItems = 'center'
        pauseButton.style.width = button_width
        pauseButton.style.height = button_height
        pauseButton.style.borderWidth = button_border_width
        pauseButton.style.borderColor = button_border_color
        pauseButton.style.borderRadius = button_border_radius
        //pauseButton.style.borderStyle = button_border_style
        pauseButton.style.backgroundColor = button_background_color
        pauseButton.style.cursor = 'pointer'
        playButton.setAttribute('href', '#play-storyflash-audio')
        pauseButton.setAttribute('href', '#pause-storyflash-audio')
        playButtonImage.setAttribute('src', 'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjYuOTUgMzEuMTciPgogIDxnPgogICAgPHBhdGggZD0iTTI2LjIsMTYuNTZjMS0uNSwxLTEuNSwwLTJMMS43LjI2Qy43LS4zNCwwLC4xNiwwLDEuMjZ2MjguN2MwLDEuMS44LDEuNSwxLjcsMWwyNC41LTE0LjNoMHYtLjFaIi8+CiAgPC9nPgo8L3N2Zz4=')
        pauseButtonImage.setAttribute('src', 'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTcuNiAzMi43Ij4KICA8Zz4KICAgIDxnPgogICAgICA8cmVjdCB3aWR0aD0iNSIgaGVpZ2h0PSIzMi43IiByeD0iMiIgcnk9IjIiLz4KICAgICAgPHJlY3QgeD0iMTIuNiIgd2lkdGg9IjUiIGhlaWdodD0iMzIuNyIgcng9IjIiIHJ5PSIyIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4=')
        playButtonImage.style.width = '27px'
        playButtonImage.style.height = '32px'
        playButtonImage.style.marginLeft = '3px'
        pauseButtonImage.style.width = '18px'
        pauseButtonImage.style.height = '32px'
        pauseButtonImage.style.marginLeft = '1px'

        if (!button_has_background) {
            playButton.style.backgroundColor = 'transparent'
            pauseButton.style.backgroundColor = 'transparent'
        }

        /* Set button color */
        setButtonColor(playButtonImage)
        setButtonColor(pauseButtonImage)

        /* Append */
        playButton.append(playButtonImage)
        pauseButton.append(pauseButtonImage)

        /* Meta */
        metaContainer.style.display = 'flex'
        metaContainer.style.flexDirection = 'row'
        metaContainer.style.justifyContent = 'space-between'
        metaContainer.style.alignItems = 'center'
        metaContainer.style.lineHeight = '1'
        metaContainer.style.color = text_color

        /* Time */
        timeContainer.style.fontSize = text_size
        timeContainer.style.lineHeight = '1'
        timeDivider.style.fontFamily = text_font
        timeDivider.style.fontSize = text_size
        timeDivider.textContent = ' / '
        timeRemaining.style.fontFamily = text_font
        timeRemaining.style.fontWeight = 'bold'
        timeRemaining.style.fontSize = text_size
        timeRemaining.textContent = '00:00'
        timePlayed.style.fontFamily = text_font
        timePlayed.style.fontWeight = 'bold'
        timePlayed.style.fontSize = text_size
        timePlayed.textContent = '00:00'
        timeTotal.style.fontFamily = text_font
        timeTotal.style.fontWeight = 'bold'
        timeTotal.style.fontSize = text_size
        timeTotal.textContent = '00:00'

        //timeContainer.append(timeRemaining)
        timeContainer.append(timePlayed)
        timeContainer.append(timeDivider)
        timeContainer.append(timeTotal)

        /* Controls */
        controlsContainer.style.lineHeight = '1'
        controlsContainer.style.fontFamily = text_font
        controlsContainer.style.fontSize = text_size
        controlsContainer.style.fontWeight = 'bold'
        controlsContainer.style.display = 'flex'
        controlsContainer.style.flexDirection = 'row'
        controlsContainer.style.justifyContent = 'flex-start'
        controlsContainer.style.alignItems = 'center'
        controlsContainer.style.flex = '1 auto'
        controlsContainer.style.margin = '0 12px'

        /* playbackRate list */
        playbackRateList.classList.add('storyflash-audio-player-meta-controls-playbackrate')
        playbackRateList.style.display = 'flex'
        playbackRateList.style.flexDirection = 'row'
        playbackRateList.style.justifyContent = 'flex-start'
        playbackRateList.style.alignItems = 'center'
        playbackRateList.style.listStyleType = 'none'
        playbackRateList.style.margin = '0 0 0 0'
        playbackRateList.style.padding = '0 0 0 0'

        /* Playback Rate */
        for (var i=1;i<=2;i+=0.25) {
            let playbackRateItem = document.createElement('li'),
                playbackRateButton = document.createElement('a')

            playbackRateItem.style.listStyle = 'none'
            playbackRateButton.setAttribute('href', '#'+i)
            playbackRateButton.setAttribute('data-playback-rate', i)
            playbackRateButton.textContent = i+'x'
            playbackRateButton.style.color = text_color
            playbackRateButton.style.padding = '0 6px'
            playbackRateButton.style.textDecoration = 'none'
            playbackRateButton.addEventListener('click', function(ev) {
                ev.preventDefault()
                let activeIndex = Array.from(playbackRateList.querySelectorAll('li')).indexOf(ev.target.closest('li')),
                    lastIndex = playbackRateList.querySelectorAll('li').length - 1,
                    nextIndex = (activeIndex + 1) > lastIndex ? 0 : activeIndex + 1,
                    nextItem = playbackRateList.querySelector('li:nth-child('+(nextIndex+1)+')')

                ev.target.closest('li').style.display = 'none'
                nextItem.style.display = 'block'
                mediaElem.playbackRate = nextItem.querySelector('a').getAttribute('data-playback-rate')
            })

            playbackRateItem.append(playbackRateButton)
            playbackRateList.append(playbackRateItem)
        }

        /* Skip List */
        skipList.classList.add('storyflash-audio-player-meta-controls-skip')
        skipList.style.display = 'flex'
        skipList.style.flexDirection = 'row'
        skipList.style.justifyContent = 'flex-start'
        skipList.style.alignItems = 'center'
        skipList.style.listStyleType = 'none'
        skipList.style.margin = '0 0 0 0'
        skipList.style.padding = '0 0 0 0'

        rewindButton.setAttribute('href', '#rewind')
        rewindButton.style.color = text_color
        rewindButton.style.textDecoration = 'none'
        rewindButton.style.padding = '0 6px'
        //rewindButton.innerHTML = '<< 10s'
        rewindButton.addEventListener('click', function(ev) {
            ev.preventDefault()
            mediaElem.currentTime = mediaElem.currentTime - 10
        })
        forwardButton.setAttribute('href', '#forward')
        forwardButton.style.color = text_color
        forwardButton.style.textDecoration = 'none'
        rewindButton.style.padding = '0 6px'
        //forwardButton.textContent = '10s >>'
        forwardButton.addEventListener('click', function(ev) {
            ev.preventDefault()

            mediaElem.currentTime = mediaElem.currentTime + 10
        })

        let rewindButtonImage = document.createElement('img'),
            forwardButtonImage = document.createElement('img')

        rewindItem.style.listStyle = 'none'
        forwardItem.style.listStyle = 'none'

        rewindButtonImage.setAttribute('src', 'data:image/svg+xml;base64,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')
        rewindButtonImage.style.width = '23px'
        rewindButton.append(rewindButtonImage)
        forwardButtonImage.setAttribute('src', 'data:image/svg+xml;base64,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')
        forwardButtonImage.style.width = '23px'
        forwardButton.append(forwardButtonImage)
        rewindItem.append(rewindButton)
        forwardItem.append(forwardButton)

        setSkipButtonColor(rewindButtonImage)
        setSkipButtonColor(forwardButtonImage)

        skipList.append(rewindItem, forwardItem)
        if (!show_skip_buttons) {
            skipList.style.display = 'none'
        }

        playbackRateList.querySelectorAll('li:not(:first-child)').forEach((elem) => {
            elem.style.display = 'none'
        })

        controlsContainer.append(playbackRateList, skipList)

        /* Branding */
        brandingLink.setAttribute('href', 'https://www.article-reader.de')
        brandingLink.setAttribute('target', '_blank')
        brandingLink.style.display = 'block'
        brandingLogo.setAttribute('src', 'data:image/png;base64,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')
        brandingLogo.style.height = '16px'
        brandingLogo.style.display = 'block'
        brandingLink.append(brandingLogo)
        brandingContainer.append(brandingLink)

        actionsContainer.append(playButton, pauseButton)
        metaContainer.append(timeContainer, controlsContainer, brandingContainer)

        visualisationContainer.append(waveformContainer)
        visualisationContainer.append(progressbarContainer)

        infoContainer.append(visualisationContainer, metaContainer)

        topContainer.append(actionsContainer, infoContainer)
        //bottomContainer.append(metaContainer)
        playerContainer.append(headlineContainer)

        playerContainer.append(topContainer)

        setButtonHasBorder(button_has_border)

        playButton.addEventListener('click', (ev) => {
            ev.preventDefault()
            playButton.style.display = 'none'
            pauseButton.style.display = 'flex'

            if (prerollAudio.src && preroll_played == false) {
                ad_in_progress = true
                preroll_played = false
                pauseButton.style.opacity = 0.5
                pauseButton.style.cursor = 'default'
                controlsContainer.style.opacity = 0.5
                controlsContainer.querySelectorAll('a').forEach((elem) => {
                    elem.style.pointerEvents = 'none'
                    elem.style.cursor = 'default'
                })
                prerollAudio.play()
                prerollAudio.addEventListener('ended', function(ev) {
                    ad_in_progress = false
                    preroll_played = true
                    pauseButton.style.opacity = 1
                    pauseButton.style.cursor = 'pointer'
                    controlsContainer.style.opacity = 1
                    controlsContainer.querySelectorAll('a').forEach((elem) => {
                        elem.style.pointerEvents = 'auto'
                        elem.style.cursor = 'pointer'
                    })
                    mediaElem.play()
                })
            } else {
                mediaElem.play()
            }

            let statistic_request_url = statistic_url,
                event_name = 'play'

            if (
                baseName != null &&
                baseName == 'player_summary'
            ) {
                statistic_request_url = summary_statistic_url
                event_name = 'play_summary'
            }

            /* Make fetch call */
            if (statistics_send['play'] == false) {
                let response = fetch(statistic_request_url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({article_url: article_url, hash: player_hash, event: event_name})
                }).then(api_response => {
                    if (!api_response.ok) {
                        if (api_response.status === 404) {
                            throw new Error('Data not found')
                        } else if (api_response.status === 500) {
                            throw new Error('Server error')
                        } else {
                            throw new Error('Network response was not ok')
                        }
                    }
                    return api_response.json()
                }).then(data => {
                    statistics_send['play'] = true
                }).catch(error => {
                    console.error('Error:', error)
                })
            }
        })
        pauseButton.addEventListener('click', (ev) => {
            ev.preventDefault()
            if (ad_in_progress == false) {
                pauseButton.style.display = 'none'
                playButton.style.display = 'flex'

                mediaElem.pause()
            }
        })

        window.dispatchEvent(player_setup_done_event);
    } else {
        //document.querySelector('[data-storyflash-audio-player]').remove()
    }
},
sendStatistics = () => {

},
setButtonColor = (buttonElem, color = null) => {
    let new_color = button_color
    if (color != null) {
        new_color = color
    }
    let base64_src = buttonElem.src.substring(26),
        decoded_svg = atob(base64_src),
        wrapper = document.createElement('div')

    wrapper.innerHTML = decoded_svg

    let svg = wrapper.firstChild,
        paths = svg.getElementsByTagName('path'),
        rects = svg.getElementsByTagName('rect'),
        polygons = svg.getElementsByTagName('polygon')

    if (paths != undefined && paths.length > 0) {
        for (let path of paths) {
            if (path.getAttribute('fill') != 'none') {
                path.setAttribute('fill', new_color)
            }
            if (
                path.getAttribute('stroke') != null &&
                path.getAttribute('stroke') != 'none'
            ) {
                path.setAttribute('stroke', new_color)
            }
        }
    }

    if (rects != undefined && rects.length > 0) {
        for (let i = 0; i < rects.length; i++) {
            rects[i].setAttribute('fill', new_color)
        }
    }

    if (polygons != undefined && polygons.length > 0) {
        for (let i = 0; i < polygons.length; i++) {
            polygons[i].setAttribute('fill', new_color)
        }
    }

    let s = new XMLSerializer().serializeToString(svg),
        base64_encode = 'data:image/svg+xml;base64,' + btoa(s)

    buttonElem.src = base64_encode
},
setSkipButtonColor = (buttonElem, color = null) => {
    let new_color = skip_button_color
    if (color != null) {
        new_color = color
    }
    let base64_src = buttonElem.src.substring(26),
        decoded_svg = atob(base64_src),
        wrapper = document.createElement('div')

    wrapper.innerHTML = decoded_svg

    let svg = wrapper.firstChild,
        paths = svg.getElementsByTagName('path'),
        rects = svg.getElementsByTagName('rect'),
        polygons = svg.getElementsByTagName('polygon')

    if (paths != undefined && paths.length > 0) {
        for (let path of paths) {
            if (path.getAttribute('fill') != 'none') {
                path.setAttribute('fill', new_color)
            }
            if (
                path.getAttribute('stroke') != null &&
                path.getAttribute('stroke') != 'none'
            ) {
                path.setAttribute('stroke', new_color)
            }
        }
    }

    if (rects != undefined && rects.length > 0) {
        for (let i = 0; i < rects.length; i++) {
            rects[i].setAttribute('fill', new_color)
        }
    }

    if (polygons != undefined && polygons.length > 0) {
        for (let i = 0; i < polygons.length; i++) {
            polygons[i].setAttribute('fill', new_color)
        }
    }

    let s = new XMLSerializer().serializeToString(svg),
        base64_encode = 'data:image/svg+xml;base64,' + btoa(s)

    buttonElem.src = base64_encode
},
setTextColor = (textContainer, color = null) => {
    let new_color = text_color
    if (color != null) {
        new_color = color
    }
    textContainer.style.color = new_color
    document.querySelectorAll('[data-playback-rate]').forEach((elem) => {elem.style.color = color})
    text_color = new_color
},
setHeadline = (headlineText, headline_text = null) => {
    let new_headline = headline
    if (headline_text != null) {
        new_headline = headline_text
    }
    headlineText.textContent = new_headline
    headline = new_headline
},
setHeadlineSize = (headlineText, headline_font_size = null) => {
    let new_size = headline_size
    if (headline_font_size != null && headline_font_size != '') {
        new_size = headline_font_size
    }
    if (headline_font_size == '') {
        new_size = base_headline_size
    }
    headlineText.style.fontSize = new_size
    headline_size = new_size
},
setHeadlineFont = (headlineText, headline_font_family = null) => {
    let new_font = headline_font
    if (headline_font_family != null && headline_font_family != '') {
        new_font = headline_font_family
    }
    if (headline_font_family == '') {
        new_font = base_headline_font
    }
    headlineText.style.fontFamily = new_font
    headline_font = new_font
},
setHeadlineColor = (headlineText, color = null) => {
    let new_color = headline_color
    if (color != null) {
        new_color = color
    }
    headlineText.style.color = new_color
    text_color = new_color
},
setProgressColor = (color = null) => {
    let new_color = progress_color
    if (color != null) {
        new_color = color
    }
    wavesurfer.setOptions({'progressColor': new_color})
    document.querySelector('.storyflash-audio-player-progressbar-dot').style.backgroundColor = new_color
    document.querySelector('.storyflash-audio-player-progressbar-progress').style.backgroundColor = new_color
    progress_color = new_color
},
setBackgroundColor = (backgroundContainer, color = null) => {
    let new_color = background_color
    if (color != null) {
        new_color = color
    }
    backgroundContainer.style.backgroundColor = new_color
    background_color = new_color
},
setBorderColor = (borderContainer, color = null) => {
    let new_color = border_color
    if (color != null) {
        new_color = color
    }

    borderContainer.style.borderColor = new_color
    border_color = new_color
},
setBorder = (borderContainer, border = false) => {
    if (border == true) {
        borderContainer.style.borderStyle = 'solid'
        borderContainer.style.borderWidth = '1px'
        borderContainer.style.padding = '12px'
    } else {
        borderContainer.style.borderStyle = 'solid'
        borderContainer.style.borderWidth = '0px'
        borderContainer.style.padding = '0'
    }
    has_border = border
},
setButtonHasBorder = (border = false) => {
    if (border == true) {
        document.querySelector('.storyflash-audio-player-actions-play').style.borderStyle = 'solid'
        document.querySelector('.storyflash-audio-player-actions-pause').style.borderStyle = 'solid'
    } else {
        document.querySelector('.storyflash-audio-player-actions-play').style.borderStyle = 'none'
        document.querySelector('.storyflash-audio-player-actions-pause').style.borderStyle = 'none'
    }
    button_has_border = border
},
setButtonHasBackground = (bg = false) => {
    if (bg == true) {
        document.querySelector('.storyflash-audio-player-actions-play').style.backgroundColor = button_background_color
        document.querySelector('.storyflash-audio-player-actions-pause').style.backgroundColor = button_background_color
    } else {
        document.querySelector('.storyflash-audio-player-actions-play').style.backgroundColor = 'transparent'
        document.querySelector('.storyflash-audio-player-actions-pause').style.backgroundColor = 'transparent'
    }
},
setButtonBorderWidth = (border_width = '0px') => {
    document.querySelector('.storyflash-audio-player-actions-play').style.borderWidth = border_width
    document.querySelector('.storyflash-audio-player-actions-pause').style.borderWidth = border_width

    button_border_width = border_width
},
setButtonWidth = (width = '64px') => {
    document.querySelector('.storyflash-audio-player-actions-play').style.width = width
    document.querySelector('.storyflash-audio-player-actions-pause').style.width = width
    document.querySelector('.storyflash-audio-player-actions').style.width = width

    button_width = width
},
setButtonHeight = (height = '64px') => {
    document.querySelector('.storyflash-audio-player-actions-play').style.height = height
    document.querySelector('.storyflash-audio-player-actions-pause').style.height = height

    button_height = height
},
setButtonBorderRadius = (border_radius = '0px') => {
    document.querySelector('.storyflash-audio-player-actions-play').style.borderRadius = border_radius
    document.querySelector('.storyflash-audio-player-actions-pause').style.borderRadius = border_radius

    button_border_radius = border_radius
},
setButtonBackground = (bg_color = 'transparent') => {
    document.querySelector('.storyflash-audio-player-actions-play').style.backgroundColor = bg_color
    document.querySelector('.storyflash-audio-player-actions-pause').style.backgroundColor = bg_color

    button_background_color = bg_color
},
setButtonBorderColor = (color = '#000000') => {
    document.querySelector('.storyflash-audio-player-actions-play').style.borderColor = color
    document.querySelector('.storyflash-audio-player-actions-pause').style.borderColor = color

    button_border_color = color
},
setLogo = (logoContainer, logo = false) => {
    if (logo == true) {
        logoContainer.style.display = 'block'
    } else {
        logoContainer.style.display = 'none'
    }
    show_logo = logo
},
setWaveform = (waveContainer, wave = false) => {
    if (wave == true) {
        waveContainer.style.display = 'block'
    } else {
        waveContainer.style.display = 'none'
    }
    show_waveform = wave
},
setSkipButtons = (skipButtonsContainer, show_skip = false) => {
    if (show_skip == true) {
        skipButtonsContainer.style.display = 'flex'
    } else {
        skipButtonsContainer.style.display = 'none'
    }
    show_skip_buttons = show_skip
},
setProgressbar = (progressbarContainer, progressbar = false) => {
    if (progressbar == true) {
        progressbarContainer.style.display = 'block'
    } else {
        progressbarContainer.style.display = 'none'
    }
    show_progress = progressbar
},
setTransparent = (transparentContainer, transparent = false) => {
    if (transparent == true) {
        transparentContainer.style.backgroundColor = ''
    } else {
        transparentContainer.style.backgroundColor = background_color
    }
    is_transparent = transparent
}

/* Add page classes */
playerLoadInterval = window.setInterval(checkForPlayer, 250)

export {
    setButtonColor,
    setSkipButtonColor,
    setTextColor,
    setHeadlineColor,
    setHeadline,
    setHeadlineSize,
    setHeadlineFont,
    setProgressColor,
    setBackgroundColor,
    setBorderColor,
    setBorder,
    setWaveform,
    setLogo,
    setSkipButtons,
    setProgressbar,
    setTransparent,
    setButtonBackground,
    setButtonBorderColor,
    setButtonBorderRadius,
    setButtonBorderWidth,
    setButtonHasBorder,
    setButtonHasBackground,
    setButtonHeight,
    setButtonWidth,
    wavesurfer
}
